<template>
  <div>
    <HistoryLogCom :fullNode="fullNode"/>

    <table class="detail-table">
      <tbody>
        <tr>
          <td class="label-col">无需复盘会</td>
          <td>
            <el-tag type="danger"
                    v-if="fullNode.project_node.node_result.no_review_meeting">
              无需复盘会
            </el-tag>
            <el-tag type="success"
                    v-else>
              需要复盘会
            </el-tag>
            <span class="form-item-tip">常规项目可不需要填写复盘会时间，开启后将跳过时间填写</span>
          </td>
        </tr>
        <tr>
          <td class="label-col">附件</td>
          <td>
            <AttachmentViewer :files="fullNode.project_node.node_result.review_meeting_files"></AttachmentViewer>
          </td>
        </tr>
        <tr>
          <td class="label-col">复盘会记录</td>
          <td>
            <template v-for="(item, index) in fullNode.project_node.node_result.review_meeting_list">
              <el-card class="box-card" style="margin-bottom: 10px">
                <div slot="header" class="clearfix">
                  <span>第 {{ item.seq_no }} 次复盘会</span>
                  <span style="float: right; padding: 3px 0" type="text">
                  <i class="el-icon-time"></i>
                  {{ item.review_meeting_time }}丨填写人: {{ item.submit_admin_name }}
                  </span>
                </div>

                <el-row :gutter="20">
                  <el-col :span="4"  v-for="(it, ind) in (item.attendees || [])" :key="ind" style="margin-bottom: 10px">
                    <el-tag type="">{{it.name}}</el-tag>
                  </el-col>
                </el-row>
              </el-card>

<!--              <div :key="index" class="record-item">-->
<!--                <el-tag type="">第 {{ item.seq_no }} 次</el-tag>-->
<!--                <span>-->
<!--                  <i class="el-icon-time"></i>-->
<!--                  {{ item.review_meeting_time }}丨填写人: {{ item.submit_admin_name }}-->
<!--                </span>-->
<!--              </div>-->
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import AttachmentViewer from '@views/project/node-views/AttachmentViewer.vue'
import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'

export default {
  components: {HistoryLogCom, AttachmentViewer},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {
      node: {
        node_result: {}
      },
    }
  },
  created () {},
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.form-item-tip {
  font-size: 12px;
  color: #909399;
  margin-left: 10px;
}
.record-item {
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}
.detail-table {
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  table-layout: fixed;
}
.detail-table td {
  padding: 12px 10px;
  border: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
}
.detail-table .label-col {
  width: 100px;
  background-color: #fafafa;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/ReviewMeetingView.vue